import { IAppState } from '../../../AppModulesWrapper';
import { ERestrictionType } from '../../reducers/v2';

export function selectIsSubagentLimitExceed(state: IAppState): boolean {
  return state.servicePickerWidgetV2.promotion.restriction.restrictionType === ERestrictionType.SubAgentLimitExceeded;
}
